import { StatisticsCard } from "src/components";
import type { OrganizationReportRow } from "src/models";

interface IProps {
  isLoading: boolean;
  data: OrganizationReportRow[] | undefined;
}

const OrganizationReportResultsSummary = (props: IProps) => {
  const teamsCount = new Set(props.data?.filter((x) => x.teamId != null).map((x) => x.teamId)).size;
  const rolesCount = new Set(props.data?.filter((x) => x.roleId != null).map((x) => x.roleId)).size;
  const peopleCount = new Set(props.data?.map((x) => x.personId)).size;

  return (
    <StatisticsCard
      isLoading={props.isLoading}
      data={[
        { title: "Teams", value: teamsCount },
        { title: "Roles", value: rolesCount },
        { title: "People", value: peopleCount },
      ]}
    />
  );
};

export { OrganizationReportResultsSummary };
